import { Injectable } from '@angular/core';
import { SocialAuthService, SocialUser} from '@abacritt/angularx-social-login';
import { BehaviorSubject, Subject} from "rxjs";
import { OauthService} from "../oauth/oauth.service";
import { environment } from '../../../environments/environment';
import { StaticTokenHolderService } from '../auth/static-token-holder.service';
import { JwtHelperService } from '@auth0/angular-jwt';

@Injectable()
export class GoogleAuthenticationService {

  user = new SocialUser();
  isLoggedInSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  isLoggedIn$ = this.isLoggedInSubject.asObservable();
  authServiceReady : Subject<boolean>;
  private jwtHelper = new JwtHelperService();

  private get useStaticTokenOnly(): boolean {
    return (environment as { disableGoogleAutoLogin?: boolean }).disableGoogleAutoLogin === true;
  }

  constructor(
    private readonly authService: SocialAuthService,
    private readonly _oauthService: OauthService,
    private readonly staticTokenHolder: StaticTokenHolderService
  ) {
    this.authServiceReady = new Subject<boolean>();
    this.authServiceReady.next(false);
    if (this.useStaticTokenOnly) {
      this.ingresarConTokenEstatico();
    } else {
      this.ingresar();
    }
  }

  /** Rellena this.user desde el payload del JWT (nombre, email, foto) para mostrar en topbar */
  private rellenarUsuarioDesdeToken(): void {
    const token = this.staticTokenHolder.getToken();
    if (!token) return;
    try {
      const payload = this.jwtHelper.decodeToken(token) as Record<string, unknown>;
      if (payload) {
        this.user.name = (payload['name'] as string) ?? '';
        this.user.email = (payload['email'] as string) ?? '';
        this.user.firstName = (payload['given_name'] as string) ?? (payload['name'] as string) ?? '';
        this.user.photoUrl = (payload['picture'] as string) ?? '';
      }
    } catch (_err: unknown) {
      // Token inválido o expirado; se deja user vacío
    }
  }

  /** En local con token estático: llama a roles sin depender de Google y permite acceso aunque falle el backend */
  private ingresarConTokenEstatico(): void {
    this._oauthService.aoutUser().subscribe({
      next: (roles: any) => {
        this.isLoggedInSubject.next((roles?.roles?.length ?? 0) > 0);
        this.rellenarUsuarioDesdeToken();
      },
      error: () => {
        this.isLoggedInSubject.next(true);
        this.rellenarUsuarioDesdeToken();
      }
    });
  }

  ingresar(): void {
    this.authService.initState.subscribe(value => {
      if (value) {
        this.authService.authState.subscribe((user: SocialUser) => {
          this.user = user;
          if(user != null){
            if (user.idToken) {
              this.staticTokenHolder.setToken(user.idToken);
            }
            this._oauthService.aoutUser().subscribe({
              next: (roles: any) => {
                this.isLoggedInSubject.next((roles?.roles?.length ?? 0) > 0);
              },
              error: () => {
                this.isLoggedInSubject.next(false);
              }
            });
          }
        });
      }
    });
  }

  get getSocialUser(): SocialUser {
    return this.user;
  }

  logout(): void {
    this.isLoggedInSubject.next(false);
    const envToken = (environment as { staticToken?: string }).staticToken ?? '';
    this.staticTokenHolder.setToken(envToken);
  }
}
